

import { AddLeadModal } from './triageDeskShared';
import { tabForExistingMatch } from './triageDeskTypes';
import { useTriageController } from './useTriageController';
export function TriageIntakeDialog({ ctx }: { ctx: ReturnType<typeof useTriageController> }) {
const { setTab, setSearch, setToasts, productOptions, addLeadOpen, setAddLeadOpen, setLeadsRefresh, setExistingFocus } = ctx;
return (<>{addLeadOpen && (
        <AddLeadModal
          productOptions={productOptions}
          onClose={() => setAddLeadOpen(false)}
          onCreated={(name) => {
            setAddLeadOpen(false);
            // The created lead is UNVERIFIED + UNASSIGNED → Unassigned tab.
            setTab('unassigned');
            setSearch('');
            setLeadsRefresh((n) => n + 1);
            const toastId = Math.random().toString(36).slice(2);
            setToasts((t) => [...t, { id: toastId, text: `Lead "${name}" added to the Unassigned queue` }]);
            setTimeout(() => setToasts((tt) => tt.filter((x) => x.id !== toastId)), 5000);
          }}
          onOpenExisting={(m, phone) => {
            // Deep-link: close the modal, jump to the tab holding the match,
            // and search by the phone's last-10 so the row surfaces.
            setAddLeadOpen(false);
            setTab(tabForExistingMatch(m));
            const digits = phone.replace(/\D/g, '');
            setSearch(digits.length >= 10 ? digits.slice(-10) : phone);
            // 2026-10-22 (Deepika): also OPEN the lead — the panel above the table shows it with its actions.
            setExistingFocus({ id: m.existingLeadId, name: m.name ?? null, sourceName: m.sourceName ?? null, assignedToName: m.assignedToName ?? null, location: m.location ?? null });
          }}
        />
      )}
    </>);
}
